import { FindCollectionsFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { Collection, CollectionOriginEnum } from '../../collections/collections.types';
import { OfflineDatabaseCollection } from '../database/offlineDatabase/types/offlineDatabaseCollection.types';

export class OfflineCollectionTransformers {
  static toFilterOptionsCollection(
    data: OfflineDatabaseCollection,
  ): FindCollectionsFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
    };
  }

  static toCollection(data: OfflineDatabaseCollection): Collection {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      origin: CollectionOriginEnum.TECEO,
    };
  }
}
